import * as React from "react";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input-new/Input";
import Tags from "../../Tags/Tags";

const PropertyInfo = ({isAgent, data, handleChangeDropdown, handleChangeInput, getTenantsForTags, viewMode, deleted, isReferral, isFinancing, isStriveFinancing, redirectToHscTracking}) => {
    return (
        <div className="Property-info">
            <div className="Property-info_column">
                <Input
                    className="Property-info_column_item"
                    required
                    valueType="text"
                    name="NAME"
                    label="Property Name"
                    value={data.NAME}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Property-info_column_item"
                    valueType="text"
                    name="ADDRESS"
                    label="Address"
                    value={data.ADDRESS}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Property-info_column_item"
                    valueType="text"
                    name="CITY"
                    label="City"
                    value={data.CITY}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    value={data.STATE}
                    valueKey="STATE"
                    label="State"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Property-info_column_item"
                    valueType="text"
                    name="ZIP"
                    label="Zip"
                    value={data.ZIP}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                {
                    !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        valueType="text"
                        name="YEAR_BUILT"
                        label="Year Built"
                        value={data.YEAR_BUILT}
                        disabled={isAgent}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
            </div>
            <div className="Property-info_column">
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="source"
                    value={data.SOURCE}
                    valueKey="SOURCE"
                    label="Source"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="transaction"
                    value={data.TRANSACTION_TYPE}
                    valueKey="TRANSACTION_TYPE"
                    label="Transaction Type"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="market"
                    value={data.MARKET}
                    valueKey="MARKET"
                    label="Market"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                {
                    !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        valueType="integer"
                        name="SQFT"
                        label="Square Feet"
                        value={data.SQFT}
                        disabled={isAgent}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
            </div>
            <div className="Property-info_column">
                <Dropdown
                    className="Property-info_column_item"
                    optionKey="code"
                    optionLabelKey="name"
                    data={data}
                    isFromProperty
                    optionsType="category"
                    value={data.CATEGORY}
                    valueKey="CATEGORY"
                    label="Property Category"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />

                {
                    data.CATEGORY === "industrial" && !isReferral && !isFinancing &&
                    <Dropdown
                        className="Property-info_column_item"
                        data={data}
                        isFromProperty
                        optionsType="propertySubcategory"
                        value={data.PROPERTY_SUBCATEGORY}
                        valueKey="PROPERTY_SUBCATEGORY"
                        label="Property Subcategory"
                        disabled={isAgent}
                        handleParentChange={handleChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                {
                    data.TYPE === "STNL" && !isReferral && !isFinancing &&
                    (data.CATEGORY !== "industrial" ?
                        <Dropdown
                            className="Property-info_column_item"
                            data={data}
                            isFromProperty
                            optionsType="subcategorySTNL"
                            value={data.SINGLE_TENANT_SUBCATEGORY}
                            valueKey="SINGLE_TENANT_SUBCATEGORY"
                            label="Tenant Subcategory"
                            disabled={isAgent}
                            handleParentChange={handleChangeDropdown}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                        :
                        <Dropdown
                            className="Property-info_column_item"
                            data={data}
                            isFromProperty
                            optionsType="subcategoryIndustrialSTNLMT"
                            value={data.SINGLE_TENANT_SUBCATEGORY}
                            valueKey="SINGLE_TENANT_SUBCATEGORY"
                            label="Tenant Subcategory"
                            disabled={isAgent}
                            handleParentChange={handleChangeDropdown}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                    )
                }
                {
                    data.TYPE === "MT" && !isReferral && !isFinancing &&
                    (data.CATEGORY !== "industrial" ?
                        <Dropdown
                            className="Property-info_column_item"
                            data={data}
                            isFromProperty
                            optionsType="subcategoryMT"
                            value={data.MULTI_TENANT_SUBCATEGORY}
                            valueKey="MULTI_TENANT_SUBCATEGORY"
                            label="Tenant Subcategory"
                            disabled={isAgent}
                            handleParentChange={handleChangeDropdown}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                        :
                        <Dropdown
                            className="Property-info_column_item"
                            data={data}
                            isFromProperty
                            optionsType="subcategoryIndustrialSTNLMT"
                            value={data.MULTI_TENANT_SUBCATEGORY}
                            valueKey="MULTI_TENANT_SUBCATEGORY"
                            label="Tenant Subcategory"
                            disabled={isAgent}
                            handleParentChange={handleChangeDropdown}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                    )
                }
                <Dropdown
                    className="Property-info_column_item"
                    optionKey="code"
                    optionLabelKey="name"
                    data={data}
                    isFromProperty
                    optionsType="type"
                    value={data.TYPE}
                    valueKey="TYPE"
                    label="Property Type"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                {
                    data.TYPE === "STNL" && !isReferral && !isFinancing &&
                    <React.Fragment>
                        <Dropdown
                            className="Property-info_column_item"
                            data={data}
                            isFromProperty
                            optionsType="lease"
                            value={data.LEASE_TYPE}
                            valueKey="LEASE_TYPE"
                            label="Lease Type"
                            disabled={isAgent}
                            handleParentChange={handleChangeDropdown}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                        <Input
                            className="Property-info_column_item"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            valueType="date"
                            name="LEASE_COMMENCEMENT_DATE"
                            label="Lease Commencement Date"
                            value={data.LEASE_COMMENCEMENT_DATE}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                        <Input
                            className="Property-info_column_item"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            valueType="date"
                            name="LEASE_EXPIRATION_DATE"
                            label="Lease Expiration Date"
                            value={data.LEASE_EXPIRATION_DATE}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                    </React.Fragment>
                }
                {
                    data.TYPE === "MT" && !isReferral && !isFinancing &&
                    <Tags
                        className="Property-info_column_item"
                        values={getTenantsForTags(data.TENANT_ID).map((el) => el.NAME)}
                        label="Tenant"
                        deleted={deleted}
                    />
                }
                {
                    !isAgent && (isFinancing || isStriveFinancing) && ['Courting', 'Loan In Process'].includes(data.HSC_STATUS) &&
                    <button type='button'
                            className='button-new positive'
                            onClick={redirectToHscTracking}>
                        HSC Tracking
                    </button>
                }
            </div>
        </div>
    );
};

export default PropertyInfo;
